import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FillerNavItem } from 'src/app/Model/FillerNavItem.model';
import { RequestModel } from 'src/app/Model/Request.model';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-context-form',
  templateUrl: './context-form.component.html',
  styleUrls: ['./context-form.component.css']
})
export class ContextFormComponent {



  @Input() fillerNav!: FillerNavItem;
  @Input() request: RequestModel;
  @Output() navClicked: EventEmitter<any> = new EventEmitter();
  @Input() step = 0;

  constructor(private readonly translate: TranslateService) { }

  ClickNav() {
    if (this.request.Id != null && this.request.Id > 0) {
      this.navClicked.emit(this.fillerNav.link)
    }
    else
      Swal.fire({
        icon: 'warning',
        text: this.translate.instant("Request.Messages.IncompleteOverview"),
        showConfirmButton: false,
        timer: 2000
      })

  }



}
